import { BUSINESS_SETTINGS_ENDPOINTS } from "@/config/api";
import { httpClient } from "@/lib/http";
import type { ApiResponse } from "@/types/api";

import type {
    BusinessSettingsSnapshot,
    UpdateBusinessSettingsRequest,
} from "../types";

export const getBusinessSettings = async () => {
    const { data } = await httpClient.get<ApiResponse<BusinessSettingsSnapshot>>(
        BUSINESS_SETTINGS_ENDPOINTS.GET
    );
    return data;
};

export const updateBusinessSettings = async (
    payload: UpdateBusinessSettingsRequest
) => {
    const { data } = await httpClient.put<ApiResponse<BusinessSettingsSnapshot>>(
        BUSINESS_SETTINGS_ENDPOINTS.UPDATE,
        payload
    );
    return data;
};
